import { render, staticRenderFns } from "./BindList.vue?vue&type=template&id=7251d4f1&scoped=true"
import script from "./BindList.vue?vue&type=script&lang=js"
export * from "./BindList.vue?vue&type=script&lang=js"
import style0 from "./BindList.vue?vue&type=style&index=0&id=7251d4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7251d4f1",
  null
  
)

export default component.exports